import Vue from "vue";
import App from "./App";
import router from "./router/index";
import store from "./store/store";

import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";

import "@/assets/css/main.scss";

Vue.use(PaperDashboard);
// bootstrap-vue
import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);

// vee-validate 3
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
// Add the required rule
extend("required", required);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
